import * as abTests from '../model/ab-tests';
import { useABTestStore } from '../model/ABTest.store';

export function useABDistribution() {
  const abStore = useABTestStore();

  const abTestsList = Object.values(abTests.AB_TESTS);

  async function loadABDistribution() {
    try {
      await abStore.getABDistribution(abTestsList);
    } catch (err) {
      console.error(err);
    }
  }

  return {
    loadABDistribution,
  };
}
